'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UserAvatar = require('./components/UserAvatar.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_UserAvatar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-avatar/lib/index.js
// module id = 1550
// module chunks = 1